import { useDppMemberPromotion } from '@/data/Content/DppMemberPromotion';
import type { DppMemberPromotion } from '@/data/dpp/types';
import { FC, ReactNode } from 'react';

type Props = {
	renderData: (promotion: DppMemberPromotion) => ReactNode;
	loadingElement?: ReactNode;
	emptyElement?: ReactNode;
};

/**
 * Renderiza la promoción DPP del cliente con sesión. Sin sesión, sin promoción vigente o si el
 * servicio falla, muestra emptyElement.
 */
export const DpMemberPromotionRender: FC<Props> = ({
	renderData,
	loadingElement = null,
	emptyElement = null,
}) => {
	const { promotion, loading } = useDppMemberPromotion();

	if (loading) {
		return <>{loadingElement}</>;
	}

	if (!promotion) {
		return <>{emptyElement}</>;
	}

	return <>{renderData(promotion)}</>;
};
